/* Black Friday landing: product carousels (arrows + mobile dots) and the Flash watermark reveal.
   Countdowns are driven by sn-bfcm.js; tabs by SN Module Nav (sn-bfcm-hub.js). */
(function () {
  'use strict';

  if (window.__snBfLanding) return;
  window.__snBfLanding = true;

  function initCarousel(root) {
    if (root.__snBfCarousel) return;
    root.__snBfCarousel = true;

    var track = root.querySelector('[data-sn-bf-track]');
    var prev = root.querySelector('[data-sn-bf-prev]');
    var next = root.querySelector('[data-sn-bf-next]');
    var nav = root.querySelector('[data-sn-bf-nav]');
    var dots = root.querySelector('[data-sn-bf-dots]');
    if (!track) return;

    function step() {
      var item = track.firstElementChild;
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function pages() {
      return Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / step()) + 1);
    }

    function buildDots() {
      if (!dots) return;
      var count = pages();
      if (dots.children.length === count) return;
      dots.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', track.scrollTo.bind(track, { left: i * step() }));
        dots.appendChild(dot);
      }
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var overflow = max > 2;
      if (nav) nav.hidden = !overflow;
      if (dots) dots.hidden = !overflow;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (dots && overflow) {
        buildDots();
        var current = Math.round(track.scrollLeft / step());
        for (var i = 0; i < dots.children.length; i++) {
          dots.children[i].setAttribute('aria-current', i === current ? 'true' : 'false');
        }
      }
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() }); });

    var frame;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initReveal(root) {
    if (root.__snBfReveal) return;
    root.__snBfReveal = true;
    if (!('IntersectionObserver' in window)) {
      root.classList.add('is-revealed');
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        root.classList.add('is-revealed');
        observer.disconnect();
      });
    }, { threshold: 0.35 });
    observer.observe(root);
  }

  /* "Add to cart" card buttons: same flow as SN Deal Ultra (cart drawer section re-render, else open). */
  function openCartDrawer(state) {
    var drawer = document.querySelector('cart-drawer');
    var sectionId = drawer ? drawer.getAttribute('data-section-id') || drawer.dataset.sectionId || '' : '';
    var html = state && state.sections && sectionId ? state.sections[sectionId] : null;
    if (drawer && html && typeof drawer.purchaseHandler === 'function') {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      try { if (typeof drawer.updateAsideProductsByParsedState === 'function') drawer.updateAsideProductsByParsedState(state); } catch (e) {}
      try { if (typeof drawer.updateEmptyStatus === 'function') drawer.updateEmptyStatus(); } catch (e) {}
      return Promise.resolve(drawer.purchaseHandler(doc, state));
    }
    try { if (drawer && typeof drawer.update === 'function') drawer.update(); } catch (e) {}
    return Promise.resolve(drawer && typeof drawer.open === 'function' ? drawer.open() : null);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-sn-bf-atc]');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    var label = btn.textContent;
    var drawer = document.querySelector('cart-drawer');
    var sectionId = drawer ? drawer.getAttribute('data-section-id') || drawer.dataset.sectionId || '' : '';
    var payload = { items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }] };
    if (sectionId) {
      payload.sections = sectionId;
      payload.sections_url = window.location.pathname;
    }
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        return openCartDrawer(data).then(function () {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
        });
      })
      .catch(function (err) {
        window.alert((err && (err.description || err.message)) || 'Could not add to cart. Please try again.');
      })
      .then(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
  });

  /* Flash allocation countdown (sn-bf-card.liquid computes the same on render): from the start (data-from, else the
     latest deal drop) the units drop by data-step every data-interval seconds down to data-min; with data-reset > 0
     they start over at data-total that many seconds after reaching the floor. */
  function latestDrop(now) {
    var drops = (window.SNBFCM && window.SNBFCM.drops) || [];
    var best = 0;
    for (var i = 0; i < drops.length; i++) {
      var t = Date.parse(drops[i]) / 1000;
      if (t && t <= now && t > best) best = t;
    }
    return best;
  }

  function updateAllocations() {
    var now = Date.now() / 1000;
    var nodes = document.querySelectorAll('[data-sn-bf-alloc][data-total]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var num = function (name) { return parseFloat(el.getAttribute(name)) || 0; };
      var total = num('data-total');
      var step = num('data-step');
      var interval = num('data-interval') || 3600;
      var min = Math.min(num('data-min'), total);
      var reset = num('data-reset');
      if (!total) continue;
      var from = num('data-from') || latestDrop(now);
      var elapsed = from && now > from ? now - from : 0;
      if (reset > 0 && step > 0) {
        var cycle = Math.ceil((total - min) / step) * interval + reset;
        elapsed = elapsed % cycle;
      }
      var left = Math.min(total, Math.max(min, total - Math.floor(elapsed / interval) * step));
      var pct = Math.round(((total - left) / total) * 100);
      var pctEl = el.querySelector('[data-sn-bf-alloc-pct]');
      var leftEl = el.querySelector('[data-sn-bf-alloc-left]');
      var bar = el.querySelector('.sn-bf-alloc__bar');
      if (pctEl) pctEl.textContent = pct;
      if (leftEl) leftEl.textContent = left;
      if (bar) {
        bar.setAttribute('aria-valuenow', pct);
        var fill = bar.querySelector('i');
        if (fill) fill.style.setProperty('--claimed', pct + '%');
      }
      el.classList.toggle('is-hot', pct >= (num('data-hot') || 80));
    }
  }

  function init(scope) {
    updateAllocations();
    var carousels = (scope || document).querySelectorAll('[data-sn-bf-carousel]');
    for (var i = 0; i < carousels.length; i++) initCarousel(carousels[i]);
    var reveals = (scope || document).querySelectorAll('[data-sn-bf-reveal]');
    for (var j = 0; j < reveals.length; j++) initReveal(reveals[j]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  window.setInterval(updateAllocations, 30000);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
